import { useState } from 'react';
import * as Yup from 'yup';

import { useLazyGetSharedListsQuery } from '../../../../../../services/contacts';

export const useSharedListFilter = ({ setFilters }) => {
  const [getSharedLists] = useLazyGetSharedListsQuery();
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const formSchema = Yup.object().shape({
    sharedListIds: Yup.array().of(
      Yup.object().shape({
        label: Yup.string().required(),
        value: Yup.number().required(),
      }),
    ),
  });

  const onSearchChange = async (currentValue) => {
    try {
      const data = await getSharedLists({
        keyword: currentValue,
        kind: 'people',
      }).unwrap();

      return data?.sharedLists?.map((item) => ({ label: item.name, value: item.id })) || [];
    } catch (error) {
      return [];
    }
  };

  const onSubmit = ({ sharedListIds }) => {
    setFilters({ sharedListIds });
  };

  const onMenuOpen = () => {
    setIsLoading(true);
    onSearchChange('').then((data) => {
      setDefaultOptions(data);
      setIsLoading(false);
    });
  };

  return {
    formSchema,
    defaultOptions,
    isLoading,
    onMenuOpen,
    onSearchChange,
    onSubmit,
  };
};
